import { Children } from "react";
import { NeuCard } from "../neu/Neu";

// الخيار (أ): القسم = مربّع نيومورفي واحد، عنوانه بالداخل أعلاه، ومحتوياته كتل مفصولة بخط خفيف.
// البطاقات الداخلية تُسطَّح عبر CSS (settings-flat) فلا تظهر صناديق داخل صناديق.
export const SettingsSection = ({ icon: Icon, title, testId, children }) => (
  <NeuCard className="settings-flat" data-testid={testId}>
    {title ? (
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-background text-primary shadow-neu-sm">
          <Icon className="h-6 w-6" />
        </span>
        <h2 className="text-start text-xl font-bold text-foreground sm:text-2xl">{title}</h2>
      </div>
    ) : null}
    <div className="settings-flat-body">
      {Children.map(children, (child, i) => (
        <div className={i ? "mt-6 border-t border-border/40 pt-6" : ""}>{child}</div>
      ))}
    </div>
  </NeuCard>
);
